import React from 'react';

const comparables = [
  { address: '38 Harbour View Tce, Mosman NSW', beds: 4, baths: 3, sold: '$2,850,000', date: 'Jan 2026', diff: '+1.8%' },
  { address: '15 Ocean St, Mosman NSW', beds: 4, baths: 2, sold: '$2,720,000', date: 'Dec 2025', diff: '-3.2%' },
  { address: '7 Clifton Rd, Mosman NSW', beds: 5, baths: 3, sold: '$3,100,000', date: 'Nov 2025', diff: '+10.7%' },
  { address: '22 Bay View Ave, Mosman NSW', beds: 4, baths: 3, sold: '$2,780,000', date: 'Oct 2025', diff: '-0.7%' },
];

const ComparableSales = () => {
  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Comparable Sales</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2 pr-4 text-muted-foreground font-medium">Address</th>
              <th className="text-center py-2 px-2 text-muted-foreground font-medium">Bed/Bath</th>
              <th className="text-right py-2 px-2 text-muted-foreground font-medium">Sale Price</th>
              <th className="text-right py-2 pl-2 text-muted-foreground font-medium">vs Listing</th>
            </tr>
          </thead>
          <tbody>
            {comparables?.map((c, i) => (
              <tr key={i} className="border-b border-border/50 hover:bg-muted/30 transition-colors">
                <td className="py-3 pr-4 text-foreground">{c?.address}</td>
                <td className="py-3 px-2 text-center text-muted-foreground">{c?.beds}b {c?.baths}ba</td>
                <td className="py-3 px-2 text-right font-medium text-foreground">{c?.sold}</td>
                <td className="py-3 pl-2 text-right">
                  <span className={`font-medium ${c?.diff?.startsWith('+') ? 'text-green-400' : 'text-red-400'}`}>{c?.diff}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-3 rounded-lg bg-muted/30 flex items-center justify-between">
        <span className="text-sm text-muted-foreground">Median comparable sale</span>
        <span className="font-semibold text-foreground">$2,812,500</span>
      </div>
    </div>
  );
};

export default ComparableSales;
